// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelActiveId0 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/activeId.js';
import ModelAnotherOrder1 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/anotherOrder.js';
import ModelCardList2 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/cardList.js';
import ModelCommon3 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/common.js';
import ModelDashboard4 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/dashboard.ts';
import ModelEditActivity5 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/editActivity.js';
import ModelLeftActivity6 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/leftActivity.js';
import ModelRecommendationProducts7 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/recommendationProducts.js';
import ModelRenderKey8 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/renderKey.js';
import ModelRightActivity9 from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/src/models/rightActivity.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'activeId', ...ModelActiveId0 });
app.model({ namespace: 'anotherOrder', ...ModelAnotherOrder1 });
app.model({ namespace: 'cardList', ...ModelCardList2 });
app.model({ namespace: 'common', ...ModelCommon3 });
app.model({ namespace: 'dashboard', ...ModelDashboard4 });
app.model({ namespace: 'editActivity', ...ModelEditActivity5 });
app.model({ namespace: 'leftActivity', ...ModelLeftActivity6 });
app.model({ namespace: 'recommendationProducts', ...ModelRecommendationProducts7 });
app.model({ namespace: 'renderKey', ...ModelRenderKey8 });
app.model({ namespace: 'rightActivity', ...ModelRightActivity9 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
